import React from 'react';
import './App.css';
import {CssBaseline, Typography, IconButton, withStyles, Dialog, Grid, Button} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import {isMobileOnly, CustomView, isMobile} from 'react-device-detect';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CloseIcon from '@material-ui/icons/Close';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Carousel from 'nuka-carousel';
import { AddCircleOutlineOutlined, RemoveCircleOutline } from '@material-ui/icons';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Divider from '@material-ui/core/Divider';
import Grow from '@material-ui/core/Grow';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import Collapse from '@material-ui/core/Collapse';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Chip from '@material-ui/core/Chip'
import Fab from '@material-ui/core/Fab'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
//import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';



const barWidth = () => {
  if (isMobile) return '100vw'
  else return '70vw'
}

const noRow = () => {
  if (isMobileOnly) return 2
  else return 4
}

const textSize1 = () =>{
  if (isMobileOnly) return 'h7'
  else return 'h5'
}

const textSize2 = () =>{
  if (isMobileOnly) return 'body1'
  else return 'body1'
}

const noSlide = () => {
  if (isMobileOnly) return 2
  else return 4.5
}

const customHeight1 = () => {
  if (isMobileOnly) return 140
  else return 150
}

const customHeight2 = () => {
  if (isMobileOnly) return 330
  else return 360
}

const customHeight3 = () => {
  if (isMobileOnly) return 100
  else return 150
}

const drawerHeight = () => {
  if(isMobileOnly) return '48.5vh'
  else return '47.5vh'
}

const customHeight4 = () => {
  if (isMobileOnly) return '27vh'
  else return '32vh'
}

const customWidth1 = () => {
  if (isMobileOnly) return '48vw'
  else return '17vw'
}

const customWidth2 = () => {
  if (isMobileOnly) return '42vw'
  else return '15vw'
}

const gridHeight = () => {
  if (isMobileOnly) return 340
  else return 370
}

const useStyles = makeStyles({

    ContentBackground:{
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#282c34',
      height: 'auto',
      display: 'flex',
      width:'100vw',
      textAlign: 'center',
      verticalAlign: 'middle',
      flexDirectison: 'columns',
    },

    title: {
      marginTop: '2vh',
      marginLeft: '2vw',
      color: 'black',
      fontWeight: 'bold'
    },

    card1: {
      maxWidth: customWidth1(),
    },

    card2: {
      maxWidth: customWidth2(),
    },

    inputCenter: {
      textAlign: "center",
      color: "red"
    }
  });

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const variantIcon = {
  success: CheckCircleIcon,
  error: ErrorIcon
};

const useStyles1 = makeStyles(theme => ({
  gridList: {
    width: barWidth(),
    height: 'auto',
  },

  success: {
    backgroundColor: green[600],
  },

  error: {
    backgroundColor: red[600],
  },

  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  
}));

function MySnackbarContentWrapper(props) {
  const classes = useStyles1();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

MySnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'error']).isRequired,
};

const useStyles2 = makeStyles(theme => ({
  margin: {
    margin: theme.spacing.unit,
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  drawerPaper: {
    height: drawerHeight()
  },
}));


function Content({reachableDatas, stateSeller, sellerName, sellerInfo, sellerDetail, suburbRef, handleChange,handleExpandClick, getList}) {
    const styleClasses = useStyles();
    const classes = useStyles2();

    const tileLengthMenu = () => {
      if (sellerInfo.length > noSlide()) return false 
      else return true
    }
    const noScroll = () => {
      if (sellerInfo.length >= 8) return 2 
      else return 1
    }
    const menuAlign = () => {
      if (isMobileOnly) return 'left'
      else return 'center'
    }

  const [promoList, setList] = React.useState([]);
  const [promoDialog, setPromoDialog] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [item, setItem] = React.useState([]);
  const [amount, setAmount] = React.useState(0);
  const [plusError,setError] = React.useState(false);
  const [addInfo,setInfo] = React.useState(false);
  const [itemSize, setSize] = React.useState([]);
  const [itemExtra, setExtra] = React.useState([]);
  const [sizeFee, setSizeFee] = React.useState({Type:'', Value: 0});
  const [extraFee, setExtraFee] = React.useState({Description: '', Value: 0});
  
  const handleClickOpen = (arg) => event => {
    event.preventDefault();
    setOpen(true);
    setItem(arg);
    setSizeFee({Type:'', Value: 0});
    setExtraFee({Description: '', Value: 0});

    let newState = []
    for (let sizeOption in arg['Size']) {
      let isChecked = false
      if (sizeOption === '0') isChecked = true
      newState.push({Type: arg['Size'][sizeOption].Type, Checked: isChecked, Value: arg['Size'][sizeOption].Value})
    }
    setSize(newState)

    let updateState = []
    for (let extraOption in arg['Extra']) {
      updateState.push({Description: arg['Extra'][extraOption].Description, Checked: false, Value: arg['Extra'][extraOption].Value})
    }
    setExtra(updateState)

    setAmount(0);
  };

  const onPromoClick = (arg) => event => {
    event.preventDefault();
    setList(arg)
    setPromoDialog(true)
  }

  const promoClose = () => setPromoDialog(false)

  const handleSizeChange = (arg) => event => {
    setSizeFee(arg)
    let newState = itemSize
    if (event.target.checked === false) {
      for (let elements in newState){
        if (newState[elements].Type === arg.Type) newState[elements].Checked = false
      }
      newState[0].Checked = true
    }
    else {
      for (let elements in newState){
        if (newState[elements].Type === arg.Type) newState[elements].Checked = true
        else newState[elements].Checked = false
      }
    } 
    setSize(newState)
  }

  const handleExtraChange = (arg) => event => {
    let newState = itemExtra
    if (event.target.checked === false) {
      for (let elements in newState){
        if (newState[elements].Description === arg.Description) newState[elements].Checked = false
      }
    }
    else {
      for (let elements in newState){
        if (newState[elements].Description === arg.Description) newState[elements].Checked = true
      }
    } 
    setExtra(newState)

    let selectedOption = '';
    let totalExtra = 0;
    for (let element in newState) {
      if (newState[element].Checked === true) {
        selectedOption = selectedOption + ` ${newState[element].Description}`
        totalExtra = totalExtra + Number(newState[element].Value)
      }
    }
    setExtraFee({
      Description: selectedOption,
      Value: totalExtra 
    })
  }

  const handleClose = () => {setOpen(false);};
  const onAdd = () => event => {
    event.preventDefault();
    if (amount < item.Available)
    { const i = amount + 1 
    setAmount(i)
    }
    else setError(true)
  }
  const onMinus = () => event => {
    event.preventDefault();
    if (amount > 0)
    { const i = amount - 1 
    setAmount(i)
    }
  }

  const addtoCart = (arg, arg2, arg3,amount,sellerName,suburbRef) => event => {
    event.preventDefault();
    setInfo(true);
    getList(arg, arg2, arg3, amount,sellerName,suburbRef);
  }

  function closeInfo(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setInfo(false);
  }

  function errorInfo (event,reason) {
    if (reason === 'clickaway') {
      return;
    }

    setError(false);
  }
    return (
      <div className = {styleClasses.ContentBackground}>
        <div className ='containerStyle' style={{width: barWidth(), overflow: 'hidden',}}>
        <CustomView condition = {(reachableDatas) && reachableDatas.length !== 0}>
          <p></p>
          <GridList cellHeight={gridHeight()} className={classes.gridList} cols ={noRow()} 
          >

            {reachableDatas.map((reachableShop) => (
            <Grow
              in={true}
              {...({ timeout: Number(reachableDatas.findIndex(arg => arg.Name === reachableShop.Name))*1000 })}
            >
            <GridListTile key={reachableShop.Logo} cols={1}>
            <Card className={styleClasses.card1} style= {{height: customHeight2()}} >
              <CardActionArea disabled = {reachableShop.Open !== 'Yes'} onClick = {handleChange(reachableShop)}>
                <CardHeader
                  style ={{backgroundColor: "white"}}
                  avatar={
                  <Avatar className={classes.large} aria-label="recipe" >
                    <img src={reachableShop.Logo} alt = {reachableShop.Name} style={{width: 'inherit', height:'inherit'}}/>
                  </Avatar>
                  }
                  title= {
                    <Typography gutterBottom variant="body1" component="h2">
                        {reachableShop.Name}
                    </Typography>
                  }
                />
                <CustomView condition={reachableShop.Open === 'Yes'}>
                  <CardMedia
                    component="img"
                    alt= {reachableShop.Name}
                    height= {customHeight1()}
                    image= {reachableShop.Promo}
                    title= {reachableShop.Name}
                  />
                </CustomView>
                <CustomView condition={reachableShop.Open !== 'Yes'}>
                  <CardMedia
                    className = "img"
                    component="img"
                    alt= {reachableShop.Name}
                    height= {customHeight1()}
                    image= {reachableShop.Promo}
                    title= {reachableShop.Name}
                  />
                </CustomView>
            </CardActionArea>
            <CardContent>
            <Grid container spacing={1}>
                { (!isMobileOnly) && 
                  <Grid item xs ={12}>
                    <Chip size ='small'
                      label = {reachableShop.Location.Address}
                    />
                  </Grid>  
                }
                <Grid item xs={6}>
                  <Chip size ='small' 
                  color = 'primary'
                  label = {reachableShop.Distance.text} 
                  />
                </Grid>
                <Grid item xs={6}>
                  <Chip size ='small'
                    color = 'primary'
                    label = {'Fee: ' + reachableShop.KmFee} 
                  />
                </Grid>
                <Grid item xs ={12}>
                  <Fab size="small" variant="extended" color="secondary" aria-label="add"
                      onClick = {onPromoClick(reachableShop.Discount)}
                       disabled = {(!reachableShop.Discount) || reachableShop.Discount.length === 0}
                  >
                    <LocalOfferIcon fontSize="small" className={classes.extendedIcon}/> 
                    Promo 
                  </Fab>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
            </GridListTile>
            </Grow>
            ))}
          </GridList>
          
          <Dialog fullScreen={isMobileOnly} onClose={promoClose} aria-labelledby="customized-dialog-title" open={promoDialog} style={{minWith:'120'}}>
            <DialogTitle id="customized-dialog-title" onClose={promoClose}></DialogTitle>
            <DialogContent >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                <TableBody>
                {promoList.map(promo => (
            <TableRow key={item.name} style={{ overflow: 'auto'}}>
            <TableCell>
                <Grid  container spacing={1}>
                    <Grid item xs ={5} style={{flexDirection: 'column', textAlign:'center',verticalAlign: 'middle', display: 'flex', alignContent: 'center', justifyContent: 'center'}}>
                        <Typography style={{color: 'red', fontWeight: 'bold'}}>
                            {promo.Code}
                        </Typography>
                    </Grid>
                    <Grid item xs ={7}>
                        <Typography style={{fontWeight: 'bold'}}>
                            {promo.Description}
                        </Typography>
                        <Typography>
                            {'*'+ promo.Condition}
                        </Typography>
                    </Grid>
                </Grid>
            </TableCell>
            </TableRow>
            ))}
                </TableBody>
                </Table>
            </TableContainer>
            </DialogContent>
        </Dialog>
      </CustomView>
    
    <CustomView condition = {!stateSeller}>
      <SwipeableDrawer
        anchor="bottom"
        open={!stateSeller}
        onClose={handleExpandClick(false)}
        onOpen={handleExpandClick(true)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
      <div style ={{backgroundColor: '#EAE1CE'}}>
          <CustomView condition = {!(sellerDetail)}>
            <Typography gutterBottom className={styleClasses.title} variant= {textSize2()} noWrap>
              {sellerName}
            </Typography>
          </CustomView>
          <CustomView condition = {!isMobileOnly && (sellerDetail)}>
          <Typography gutterBottom className={styleClasses.title} variant= {textSize2()} noWrap>
              {sellerName}{': ' + sellerDetail}
          </Typography>
          </CustomView>
          <CustomView condition = {isMobileOnly && (sellerDetail)}>
            <Typography gutterBottom className={styleClasses.title} variant= {textSize2()} noWrap>
              {sellerName + ': '}
            </Typography>
            <Typography align='left' gutterBottom className={styleClasses.title} variant= {textSize2()}>
              {sellerDetail}
            </Typography>
          </CustomView>
        </div>
        <p></p>
        <Carousel
            renderCenterLeftControls = {({ previousSlide }) => (
              <CustomView condition = {!isMobileOnly}>
                <IconButton onClick={previousSlide}>
                  <ArrowBackIosIcon/>
                </IconButton>
              </CustomView>
              )}
            renderCenterRightControls = {({ nextSlide }) => (
              <CustomView condition = {!isMobileOnly}>
                <IconButton onClick={nextSlide}>
                  <ArrowForwardIosIcon/>
                </IconButton>
              </CustomView>
            )}
        style ={{overflowY: 'hidden'}}
        slidesToScroll = {noScroll()}
        withoutControls = {tileLengthMenu()}
        wrapAround = {!isMobileOnly}
        slidesToShow={noSlide()} 
        dragging={true} 
        swiping ={true} 
        cellAlign = {menuAlign()} >
        {sellerInfo.map(tile => (

        <div>
          <Card className={styleClasses.card2} style= {{height: customHeight4()}}>
            <CardActionArea disabled = {tile.Available === 0} onClick = {handleClickOpen(tile)}>
              <CustomView condition={tile.Available !== 0}>
              <CardMedia
                component="img"
                alt= {tile.Name}
                height= {customHeight3()}
                image= {tile.ImageLink}
                title= {tile.Name}
              />
              </CustomView>
              <CustomView condition={tile.Available === 0}>
              <CardMedia className = 'img'
                component="img"
                alt={tile.Name}
                height= {customHeight3()}
                image= {tile.ImageLink}
                title= {tile.Name}
                
              />
              </CustomView>
              <CardContent>
                <Typography gutterBottom fontSize={textSize2()} component="h5">
                  {tile.Name}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
      </div>
      ))} 
      </Carousel> 
        
      </SwipeableDrawer>
        
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose}></DialogTitle>
            <DialogContent style = {{textAlign:'center', overflow: 'hidden'}}>
              <img src ={item.ImageLink} alt = {item.Name} style ={{maxHeight: '21vh', maxWidth:'70vw'}}/>
            </DialogContent>
            <DialogContent dividers style = {{textAlign:'center', overflow: 'hidden'}}>
              <Typography>
                {item.Name}
              </Typography>
            </DialogContent>
            
          <DialogContent dividers style = {{minHeight: '19vh', maxHeight: '28vh', overflowX: 'hidden'}}>
            <CustomView condition = {(item.Description)}>
              <Typography gutterBottom style ={{fontWeight: 'bold'}}>
                Description: 
              </Typography>
              <Typography gutterBottom paragraph>
                {item.Description}
             </Typography>
            </CustomView>
            
            <CustomView condition = {(item['Size']) && (item['Size'].length !== 0)}>
             <Divider/>
              <Grid container spacing={2}>
                <Grid item xs={2} >
                  <Typography style ={{fontWeight: 'bold'}}>
                    Option: 
                  </Typography>
                </Grid>

                <Grid item xs={8} style = {{textAlign: 'left', alignContent:'left', alignItems:'left'}}>
                  <FormControl>
                    <FormGroup aria-label="position" row>
                      {itemSize.map(options => (
                          <FormControlLabel
                          value= {options.Type}
                          control={<Checkbox checked ={options.Checked} onChange= {handleSizeChange(options)} value = {options.Type}/>}
                          label= {options.Type}
                          labelPlacement="start"
                        />
                      ))}
                    </FormGroup>
                  </FormControl>  
                </Grid>
              </Grid>
            </CustomView>

            <CustomView condition = {(item['Extra']) && (item['Extra'].length !== 0)}>
              <Divider/>
              <Grid container spacing={8}>
                <Grid item xs={1} >
                  <Typography style ={{fontWeight: 'bold'}}>
                    Extra: 
                  </Typography>
                </Grid>

                <Grid item xs={8} style = {{textAlign: 'left', alignContent:'left', alignItems:'left'}}>
                  <FormControl>
                    <FormGroup aria-label="position" row>
                      {itemExtra.map(options => (
                          <FormControlLabel
                          value= {options.Description}
                          control={<Checkbox checked ={options.Checked} onChange= {handleExtraChange(options)} value = {options.Description}/>}
                          label= {options.Description}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>  
                </Grid>
              </Grid>
            </CustomView>
          </DialogContent>

          <DialogContent style = {{overflowY: 'hidden'}}>
            <Grid container spacing={2}>
              <Grid item xs wrap ="nowrap" style = {{textAlign: 'center', alignContent:'center', alignItems:'center'}}>
                <Typography variant='h4' style={{color: 'goldenrod', fontWeight: 'bold'}}>
                    {(Number(item.Price) + Number(extraFee.Value) + Number(sizeFee.Value)).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs wrap ="nowrap" style = {{textAlign: 'center', alignContent:'center', alignItems:'center'}}>
                <div style = {{textAlign: 'center', alignContent:'center', alignItems:'center'}}>
                  <IconButton>
                    <RemoveCircleOutline onClick= {onMinus()}/>
                  </IconButton>
                    {amount}
                  <IconButton>
                    <AddCircleOutlineOutlined onClick = {onAdd()}/>
                  </IconButton>
                </div>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogContent style = {{overflowY: 'hidden'}}>
            <Button disabled = {amount === 0} fullWidth = {true} variant="contained" color="primary" onClick = {addtoCart(item,sizeFee, extraFee, amount,sellerName,suburbRef)}>
              ADD TO CART
            </Button>
          </DialogContent>

        </Dialog>
        
      <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center',}}
            open={addInfo}
            autoHideDuration={1200}
            onClose={closeInfo}
          >
          <MySnackbarContentWrapper
            onClose={closeInfo}
            variant="success"
            className={classes.margin}
            message= "Item has been added !"
          />
      </Snackbar>
      <Snackbar 
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center',}}
      open={plusError} 
      autoHideDuration={1000} 
      onClose={errorInfo}>
        <MySnackbarContentWrapper
            onClose={errorInfo}
            variant="error"
            className={classes.margin}
            message= "Not enough stock !"
          />
      </Snackbar>
    </CustomView>
        <CustomView condition = {!reachableDatas || reachableDatas.length === 0} >
          <div className= 'logoContent'>
            <img className = 'App-logo' src={'./bim192.png'} alt="logo"  />
            <p></p>
            <Typography gutterBottom variant={textSize1()} noWrap>
              Điền địa chỉ của bạn và nhấn biểu tượng tìm kiếm !!!
            </Typography>
            <Typography gutterBottom variant={textSize1()} noWrap>
              Enter your address and press search icon !!!
            </Typography>
          </div>
        </CustomView>
        </div>
        <CssBaseline/>
      </div>
    );
}

export default Content;